import { Check } from 'lucide-react';
import { Switch } from '@/components/ui/switch';
import { cn } from '@/lib/utils';
import { haptic } from '@/telegram';

interface ToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: string;
  disabled?: boolean;
}

export function Toggle({ checked, onChange, label, disabled = false }: ToggleProps): JSX.Element {
  return (
    <Switch
      checked={checked}
      disabled={disabled}
      aria-label={label}
      onCheckedChange={(next) => {
        haptic.select();
        onChange(next);
      }}
    />
  );
}

interface CheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  label?: string;
}

/** Круглая отметка «оплачено» с тактильным подтверждением. */
export function Checkbox({ checked, onChange, disabled = false, label }: CheckboxProps): JSX.Element {
  return (
    <button
      type="button"
      role="checkbox"
      aria-checked={checked}
      aria-label={label}
      disabled={disabled}
      className={cn(
        // Круг 28px, но зона касания 44px (псевдоэлемент): по маленькой галке пальцем мажут.
        "relative flex size-7 shrink-0 items-center justify-center rounded-full border-[1.5px] transition-all after:absolute after:-inset-2 after:content-[''] active:scale-90 disabled:opacity-50",
        checked ? 'border-ok bg-ok text-white' : 'border-border-strong text-transparent',
      )}
      onClick={() => {
        haptic.result(checked ? 'warning' : 'success');
        onChange(!checked);
      }}
    >
      <Check className="size-4" strokeWidth={2.5} aria-hidden />
    </button>
  );
}
